import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconTv$1 = /*@__PURE__*/ proxyCustomElement(class WppIconTv extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-tv", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 3.25C2.0335 3.25 1.25 4.0335 1.25 5V14C1.25 14.9665 2.0335 15.75 3 15.75H4.41778L4.04779 16.7366C3.90235 17.1245 4.09886 17.5568 4.4867 17.7022C4.87454 17.8477 5.30685 17.6512 5.45229 17.2633L6.01978 15.75H13.9803L14.5478 17.2633C14.6932 17.6512 15.1255 17.8477 15.5134 17.7022C15.9012 17.5568 16.0977 17.1245 15.9523 16.7366L15.5823 15.75H17C17.9665 15.75 18.75 14.9665 18.75 14V5C18.75 4.0335 17.9665 3.25 17 3.25H3ZM14.5055 14.25H17C17.1381 14.25 17.25 14.1381 17.25 14V5C17.25 4.86193 17.1381 4.75 17 4.75H3C2.86193 4.75 2.75 4.86193 2.75 5V14C2.75 14.1381 2.86193 14.25 3 14.25H5.49454L5.50004 14.25H14.5L14.5055 14.25Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-tv-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-tv", "wpp-icon-tv-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-tv-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-tv-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconTv$1);
      }
      break;
  } });
}

const WppIconTv = WppIconTv$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconTv, defineCustomElement };
